'use client';

import { ReactNode } from 'react';

import { Box, BoxContent, View } from '@bytel/trilogy-react-ts';

interface BoxInfoProps {
    children: ReactNode;
    header: ReactNode;
    className?: string;
}
export function BoxInfo({ children, header, className = 'is-vertical is-fullheight' }: Readonly<BoxInfoProps>) {
    return (
        <View flexable className={className}>
            <Box shadowless className='has-radius-bottom-0 mb-0'>
                <BoxContent className='has-byou-background has-text-white has-radius-bottom-0'>{header}</BoxContent>
            </Box>
            <Box shadowless className='is-bordered has-radius-top-0 flex-1'>
                <BoxContent className=''>{children}</BoxContent>
            </Box>
        </View>
    );
}
